import { ProductInformation } from "@/data/client";
import { defineStore } from "pinia";

export const useProductsStore = defineStore("products", {
  state: () => ({
    products: [] as ProductInformation[],
    faultyProducts: [] as ProductInformation[],
  }),
  actions: {
    setProducts(products: ProductInformation[]) {
      this.products.push(...products.filter((p) => !p.cannotParse));
      this.faultyProducts.push(...products.filter((p) => p.cannotParse));
    },
    emptyProductStore() {
      this.products = [];
      this.faultyProducts = [];
    },
    hasAnyProducts(): boolean {
      return this.products.length > 0;
    },
    hasAnyFaultyProducts(): boolean {
      return this.faultyProducts.length > 0;
    },
  },
});
